export default "__VITE_ASSET__KDa4DV28__"